export interface ITag {
  _id?: string;
  name: string;
  createdAt: string;
  createdBy: string;
}

export enum ITagType {
  POST = 'post',
}
export interface ICreateTagBody {
  name: string;
  type: ITagType;
}

export interface IGetTagsParams {
  type?: ITagType;
}
